import ApiModeToggle from './ApiModeToggle';
import './navigation/navigation.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="c-footer" id="contact">
      <div className="c-footer__inner">
        <p className="c-footer__text">
          Copyright &copy; {year}{' '}
          <span className="c-footer__brand">Van Gelder Groep</span>
        </p>
        <ApiModeToggle />
      </div>
    </footer>
  );
}

export default Footer;
